import styled from 'styled-components'

export const SocialIcon =styled.div`
    margin-top:1rem;
    font-size:1.5rem;
    
        &:hover{
            color: #00ffbd;
        }
    .socialLinks{

        color: var(--navColor);
            &:hover{
            color: #00ffbd;
        }
        }

        
        /* @media screen and (max-width: 1025px){
            display:none;
    }
    @media screen and (max-width: 760px){
        display:none;
    } */
    
`